module.exports = __webpack_public_path__ + "img/quickbooks_analysis.0d8c93ec.svg";